export const fractions = data => {
  return [
    1,
    parseFloat(data?.fractionMobile) || 1,
    parseFloat(data?.fractionTablet) || 1,
    parseFloat(data?.fractionLaptop) || 1,
    parseFloat(data?.fractionDesktop) || 1,
  ];
};
